// extracted by mini-css-extract-plugin
module.exports = {"Modal":"Modal_Modal__2z5pj","show":"Modal_show__1D-L5"};